import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import { ManagementContractContext, updateManagementContractContext } from "@eres/ejari-core/contexts/ManagementContractContext";
import Strings from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import FormAction from "@my-dld/components/Form/FormAction";
import FormRow from "@eres/forms-web/FormRow";
import { navigate } from "@my-dld/utils/StoreUtils";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { hideLoading, LoadableDataState, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import _ from "lodash";
import { ContractTerm } from "@eres/ejari-api/Entity/contract";
import { EjariApi } from "@eres/ejari-api";
import { getParticipantID } from "@10x/sso";
import Popup from "@my-dld/components/Popup/Popup";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { ErrorContainer } from "@eres/forms";
import { checkNonEmpty } from "../../utils";
import noEnglishConverter from "@eres/forms/converters/NoEnglishConverter";
import TextAreaInputField from "@eres/forms-web/TextAreaInputField";
import { TenancyContactAction } from "@eres/ejari-core/constants";
import CardNoData from "@my-dld/components/CardNoData";

interface Props extends RoutedViewProps {
}

interface LookupState {
	TermsTemplate?: ContractTerm[];
}

interface State extends LookupState, LoadableDataState {
	newData?: ContractTerm[];
	orgData?: ContractTerm[];
	addTermsPopup?: boolean;
	EnglishTerm?: string;
	ArabicTerm?: string;
	edit?: boolean;
	editIndex?: number;
}

class TermsConditions extends Component<Props, State> {
	static contextType = ManagementContractContext;
	context!: React.ContextType<typeof ManagementContractContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
			loadState: "loading",
		};
	}

	componentDidMount(): void {
		this.updateFromContext();
	}

	private updateFromContext = () => {
		const { additionalTerms } = this.context;
		const data = {
			orgData: additionalTerms,
			newData: additionalTerms,
		};
		this.setState( data );
	};

	render() {
		const { addTermsPopup } = this.state;
		const { action } = this.context;
		const isRenew = action === TenancyContactAction.RENEW_CONTRACT;
		const data = this.getUpdatedData();
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-12 form-group",
			errorManager: defaultErrorManager,
		};
		return <div className="tender-registration-form">
			<FormSection
				title={ Strings.terms_and_conditions }>
				{ isRenew && ( data && data.length === 0) ? <CardNoData containerClass="alert alert-warning"/> : null }
                {!isRenew ? <div className={ "d-flex flex-md-row flex-column justify-content-center mb-3 p-md-4" }>
					<button
						className={ "btn btn-grey btn_style1 mb-2 mb-md-0 me-0 me-md-2" } onClick={ this.getPredefinedTemplates }>
						{ Strings.terms_template }
					</button>
					<button
						style={ { color: "#ffffff" } }
                        className={ "btn btn-grey btn_style1" } onClick={ this.onShowAddTerms }>
						{ Strings.add_terms_conditions }
					</button>
				</div> : null }
				<FormRow { ...filedProps }>
					{
						data?.map( ( term, index ) => <div key={ index } className={ "d-flex" }>
							<div className={ "d-flex flex-lg-row flex-grow-1 card mc-terms-and-conditions" }>
								<div>{ term.EnglishTerm }</div>
								<div className={ "text-end" }>{ term.ArabicTerm }</div>
							</div>
							{ !isRenew ? <div className={ "d-flex align-items-start" }>
                                <button className="btn btn-grey mx-2" type="button" onClick={ () => this.onEditTerm( index ) }>
									<i className="fas fa-pencil-alt"/></button>
								<button
                                    className={ "btn btn-grey" } onClick={ () => {
									this.onDelete( index );
								} }><i className="fa fa-times" aria-hidden="true"/>
								</button>
							</div> : null }
						</div> )
					}
				</FormRow>
			</FormSection>
			<FormRow>
				<FormAction
					primaryActionLabel={ Strings.continue }
					onPrimaryAction={ this.onContinue }
					secondaryActionLabel={ Strings.back }
					onSecondaryAction={ this.onBack }/>
			</FormRow>
			{ addTermsPopup ? <Popup
				id={ "TermsPopup" }
				modalMainContainer={ "modal fade" }
				clickOutsideToDismiss={ false }
				showCloseButton={ true }
				closeClass={ "close modal-close-svg-icon" }
				closeSpanClass={ "close-svg-icon" }
				modalBodyContainer={ "modal-body" }
				showIcon={ false }
				title={ Strings.add_terms_conditions }
				autoOpenMount={ true }
				modalFooterContainer={ "modal-footer d-flex justify-content-center" }
				footer={ <>
					<button
						onClick={ this.onAddTerm }
						type="button" className="btn btn_1 btn_style1"
						data-uw-styling-context="true">{ this.state.edit ? Strings.edit : Strings.add }</button>
					<button
						type="button" className="btn btn-grey btn_style1"
						data-uw-styling-context="true" data-bs-dismiss="modal">{ Strings.cancel }</button>
				</> }
				onDismiss={ this.onDismiss }>
				<FormRow { ...filedProps }>
					<TextAreaInputField
						label={ Strings.english }
						id={ "EnglishTerm" }
						required={ true }/>
					<TextAreaInputField
						label={ Strings.arabic }
						id={ "ArabicTerm" }
						required={ true }
						valueConverter={ noEnglishConverter }/>
				</FormRow>
			</Popup> : null }
		</div>;
	}

	private onDelete = ( index: number ) => {
		const data = this.getUpdatedData();
		data.splice( index, 1 );
		this.setState( { ...this.state, newData: data, orgData: data } );
	};

	private onEditTerm = ( index: number ) => {
		const data = this.getUpdatedData();
		this.setState( {
			...this.state,
			editIndex: index,
			edit: true,
			EnglishTerm: data?.[ index ].EnglishTerm,
			ArabicTerm: data?.[ index ].ArabicTerm
		}, () => {
			this.onShowAddTerms();
		} );
	};

	private onAddTerm = () => {
		const errorContainer: ErrorContainer = {};
		let isValid = checkNonEmpty( this.state, "EnglishTerm", errorContainer );
		isValid = isValid && checkNonEmpty( this.state, "ArabicTerm", errorContainer );
		this.setState( { ...this.state, errorContainer: errorContainer } );
		if ( isValid ) {
			JQModal( "TermsPopup" ).hide();
			const data = this.getUpdatedData();
			if ( this.state.edit && this.state.editIndex != null ) {
				data[ this.state.editIndex ] = { EnglishTerm: this.state.EnglishTerm, ArabicTerm: this.state.ArabicTerm };
			} else {
				data.push( { EnglishTerm: this.state.EnglishTerm, ArabicTerm: this.state.ArabicTerm } );
			}
			this.setState( { ...this.state, newData: data, EnglishTerm: undefined, ArabicTerm: undefined, edit: undefined, editIndex: undefined } );
		}
	};

	private onShowAddTerms = () => {
		this.setState( { ...this.state, addTermsPopup: true }, () => {
			JQModal( "TermsPopup" ).show();
		} );
	};

	private onDismiss = () => {
		JQModal( "TermsPopup" ).hide( () => {
			this.setState( {
				...this.state,
				addTermsPopup: false,
				edit: undefined,
				editIndex: undefined,
				ArabicTerm: undefined,
				EnglishTerm: undefined
			} );
		} );
	};

	private getUpdatedData = ( state: State = this.state ) => {
		const data: ContractTerm[] = [];
		_.merge( data, state.orgData, state.newData );
		return data;
	};

	private isValid() {
		return true;
	}

	private onContinue = () => {
		if ( this.isValid() ) {
			const data = this.getUpdatedData();
			updateManagementContractContext( { ...this.context, additionalTerms: data } );
			navigate( "documents" );
		}
	};

	private getPredefinedTemplates = () => {
		showLoading();
		EjariApi.getPredefinedTermsTemplates( getParticipantID()! )
		.then( response => {
			hideLoading();
			if ( response.Response && response.Response.length > 0 ) {
				this.setState( { ...this.state, TermsTemplate: response.Response } );
			}
		} )
		.catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	};

	private onBack = () => {
		this.props.history.goBack();
	};
}

export default TermsConditions;
